var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    staticClass: "custom-placeholder",
    attrs: {
      items: _vm.collection,
      loading: _vm.loading,
      "search-input": _vm.textSearch,
      "hide-no-data": "",
      "return-object": _vm.returnObject,
      "hide-selected": _vm.hideSelected,
      "item-text": _vm.itemText,
      "item-value": _vm.itemValue,
      label: _vm.label,
      clearable: _vm.clearable,
      disabled: _vm.disabled,
      multiple: _vm.multiple,
      placeholder: _vm.placeholder,
      outlined: _vm.outlined,
      dense: _vm.dense,
      "error-messages": _vm.errorMessages,
      "hide-details": _vm.hideDetails,
      "small-chips": _vm.smallChips,
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.textSearch = $event
      },
      "update:search-input": function ($event) {
        _vm.textSearch = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "append",
        fn: function () {
          return [
            _vm.showAdd
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: { small: "", icon: "" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          $event.stopPropagation()
                                          return _vm.openDialogCreate.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        btn: "",
                                        color: "green darken-1",
                                      },
                                    },
                                    [_vm._v("mdi-plus")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3808882228
                    ),
                  },
                  [_c("span", [_vm._v("Novo")])]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "selection",
        fn: function ({ item, index }) {
          return [
            index === 0
              ? _c("span", [_vm._v(_vm._s(item[_vm.itemText]))])
              : _vm._e(),
            index === 1
              ? _c("span", { staticClass: "grey--text caption ml-1" }, [
                  _vm._v("(+" + _vm._s(_vm.model.length - 1) + " outros)"),
                ])
              : _vm._e(),
          ]
        },
      },
    ]),
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v
      },
      expression: "model",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }